<template>
  <section class="noData_container">
    <div class="result_content">
      <van-image width="45%" height="auto" fit="contain" :src="result_icon" class="result_icon">
        <template v-slot:loading>
          <van-loading type="spinner" size="100" />
        </template>
      </van-image>
      <div class="btn_box bottom">
        <van-button to="bind-car" size="large" class="blue-btn">
          重新缴费
        </van-button>
      </div>

      <!-- <div class="result_title">{{ result_title }}</div> -->
      <!-- <div @click="auxiliarySearch"
        v-if="$enumObject.getAuxiliaryByMode($enumObject.providerConfig[config.projectName].otherConfig.entreMode)"
        class="result_away">
        {{$enumObject.providerConfig[config.projectName].otherConfig.ArrerasTitle}}
      </div> -->
    </div>

    <van-divider>
      <div style="text-align:center;">
        Copyright ©
        {{$enumObject.providerConfig[config.projectName].copyrightInfo.subject}}
        <br />
      </div>
    </van-divider>
  </section>
</template>

<script>
import noData from '@/assets/payment-related/noData@2x.png'
import config from '@/config/index'
import { Divider } from 'vant'
import { mapGetters } from 'vuex'
export default {
  components: {
    [Divider.name]: Divider
  },
  computed: {
    ...mapGetters([
      "imgBtn"
    ])
  },
  data () {
    return {
      config,
      result_icon: noData,
      result_title: '您还没有相关订单'
    }
  },
  mounted () {
  },
  methods: {
    // 辅助查询
    auxiliarySearch () {
      this.$router.push({ name: 'Arrears-Bill-Index' })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData_container {
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .result_content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    height: px2rem(325);
    text-align: center;

    .result_icon {
      width: px2rem(120);
      height: auto;
      margin: 0 auto 20px;
    }

    .result_title {
      height: px2rem(40);
      line-height: px2rem(40);
      font-size: px2rem(22);
    }
    .result_away {
      height: px2rem(30);
      line-height: px2rem(30);
      color: rgb(79, 155, 218);
      font-size: px2rem(18);
    }
  }

  .button_box {
    padding: 0 10px 0;
  }

  .bottom {
    margin: 20px auto 20px;
  }

  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
}
</style>